/**
 * Helper: UX opimizations
 * -----------------------------------------------------------------------------
 * Small fixes to help with UX
 * - layout shift fixes
 * - pair these functions with styles in
 * src/styles/helpers/ux-optimizations.scss
 *
 */

/**
 * Sets the header height early before Vue loads to prevent layout shift.
 */
export function fixHeaderLoadingShift() {
  const siteHeaderContainer = document.querySelector('.js-site-header-loading')
  if (!siteHeaderContainer) {
    return
  }

  const siteHeaderHeight = siteHeaderContainer.offsetHeight
  window.cnvs.uxOptimizations.siteHeaderHeight = siteHeaderHeight

  document.documentElement.style.setProperty(
    '--header-height',
    `${siteHeaderHeight}px`,
  )

  // Elements with '.await-header' will not be visible until this loads
  document.body.classList.add('header-ready')
}
